import { render, staticRenderFns } from "./EcommerceOption.vue?vue&type=template&id=080b2be7"
import script from "./EcommerceOption.vue?vue&type=script&lang=js"
export * from "./EcommerceOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports